export default __webpack_public_path__ + "static/media/8b.bf8d1fa3.png";